module.exports = __webpack_public_path__ + "img/Steor-Icon-02.6aba67cc.svg";